import { render, staticRenderFns } from "./AgreementModal.vue?vue&type=template&id=23592fce&scoped=true&"
import script from "./AgreementModal.vue?vue&type=script&lang=js&"
export * from "./AgreementModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23592fce",
  null
  
)

export default component.exports